import { CESimpleAttributePermissionRuleAttributesBase } from './ce-simple-attribute-permission-rule-attributes-base'


export class CESimpleAttributePermissionRuleAttributes extends CESimpleAttributePermissionRuleAttributesBase {

}